import { render, staticRenderFns } from "./SendMessageSharedReplyInputBox.vue?vue&type=template&id=73a5e09c&scoped=true&lang=pug"
import script from "./SendMessageSharedReplyInputBox.vue?vue&type=script&lang=ts"
export * from "./SendMessageSharedReplyInputBox.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageSharedReplyInputBox.vue?vue&type=style&index=0&id=73a5e09c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5e09c",
  null
  
)

export default component.exports